export { default as quickExperimentIllustrationPNG } from '~/assets/images/anatomyV2/quick-experiment-illustration.png'
export { default as quickExperimentIllustrationWEBP } from '~/assets/images/anatomyV2/quick-experiment-illustration.webp'

export const QUICK_EXPERIMENT_QUESTION =
  'Place your hand on your lower back, just above your hip. Press gently. What are you feeling?'
export const SECTION_NUMBER = 1

export const QUICK_EXPERIMENT_OPTIONS = [
  { key: 'firmRidge', i18nKey: 'onboarding.quickExperiment.options.firmRidge' },
  {
    key: 'tenderSpot',
    i18nKey: 'onboarding.quickExperiment.options.tenderSpot',
  },
  {
    key: 'softTissue',
    i18nKey: 'onboarding.quickExperiment.options.softTissue',
  },
  { key: 'notSure', i18nKey: 'onboarding.quickExperiment.options.notSure' },
] as const
